import { UserInfo } from './update-user-data';

export const Account = {
  UserInfo,
};
